<template>
    <div>
        <con-tab ></con-tab>

        <need-nei ></need-nei>
    </div>
</template>

<script>
    import ConTab from "../../components/common/ConTab";
    import NeedNei from "./base/kechengxq";
    import HomeSwiper from "../../components/common/Swiper";
    // import search from "./SearchCom/search"
    export default {
        name: "gaoxiao",
        components:{
            HomeSwiper,
            ConTab,
            NeedNei,
            // search
        }
    }
</script>

<style scoped lang="less">
    .swiper_class{
        position: relative;
    }
    .nei_box{
        position: absolute;
        top: 400px;
        z-index: 9999;

    }
</style>